// Luminanza percepita approssimata (0-255) — sotto soglia = colore scuro.
// Usata da SiteHeader/SiteFooter per adattare testo/bordo quando l'admin
// imposta uno sfondo personalizzato (bgColor), senza dover scegliere a mano
// se serve testo chiaro o scuro sopra.
export function isDarkColor(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  if (!m) return false;
  const [r, g, b] = m.slice(1).map((h) => parseInt(h, 16));
  return (0.299 * r + 0.587 * g + 0.114 * b) < 128;
}
